module.exports = __webpack_public_path__ + "img/setting.3008d366.svg";